/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Property } from './Property';
export type StaySite = {
    siteId?: number;
    sizeId?: number;
    label?: string;
    rating?: number;
    offerDescription?: string;
    siteType?: StaySite.siteType;
    properties?: Array<Property>;
    number?: string;
    name?: string;
    area?: number;
    sizeFk?: number;
    minimumOccupancy?: number;
    maximumOccupancy?: number;
    petsAllowed?: boolean;
    nonSmoking?: boolean;
    tvConnection?: boolean;
    cookingFacility?: boolean;
    minibar?: boolean;
    sharedBathroom?: boolean;
    sharedShower?: boolean;
    privateBathroom?: boolean;
    privateShower?: boolean;
    refrigerator?: boolean;
    balconyOrTerrace?: boolean;
    electricity?: boolean;
    water?: boolean;
    wifi?: boolean;
    guestInformation?: string;
    imageIds?: Array<number>;
};
export namespace StaySite {
    export enum siteType {
        ROOM = 'ROOM',
        APARTMENT = 'APARTMENT',
        PITCH = 'PITCH',
        MOBILEHOME = 'MOBILEHOME',
        SITEOTHER = 'SITEOTHER',
    }
}

